import { action, flow, makeObservable, observable } from 'mobx';
import RootStore from '.';
import BaseStore from './BaseStore';
import { ReferralCodeApi } from '@/apis';
import { GetAllReferralCodeDetailResponse, GetAllReferralCodeResponse } from '@/types/http-payload/referralCode';
import { ResponseData } from '@/types/http';
import { TableState } from '@tanstack/react-table';

export default class ReferralCodeStore extends BaseStore {
    referralCodes: any[] = [];
    api: ReferralCodeApi;
    totalByStatus: Object = {};
    referralCodeDetail: any = null;

    constructor(rootStore: RootStore) {
        super(rootStore);
        makeObservable(this, {
            referralCodes: observable,
            referralCodeDetail: observable,
            createReferralCode: flow.bound,
            getAllReferralCodes: flow.bound,
            deleteReferralCode: flow.bound,
            changeStatusReferralCode: flow.bound,
            updateReferralCode: flow.bound,
            getReferralCodeDetail: flow.bound,
            getReferralCodeInfo: flow.bound
        });

        this.api = new ReferralCodeApi();
    }

    * createReferralCode(payload?: any) {
        try {
            const res: ResponseData = yield this.rootStore.apiStore.call(this.api, this.api.createReferralCode, payload);
            if (res.ok) {
                return true;
            }
        } catch (error) {
            console.log(error);
            return false;
        }
    }

    * getReferralCodeInfo(id: string | number) {
        try {
            const res: ResponseData = yield this.rootStore.apiStore.call(this.api, this.api.getReferralCodeInfo, id);
            if (res.ok) {
                return res?.data;
            }
        } catch (error) {
            console.log(error);
            return false;
        }
    }

    * deleteReferralCode(id: string | number) {
        try {
            const res: ResponseData = yield this.rootStore.apiStore.call(this.api, this.api.deleteReferralCode, id);
            if (res.ok) {
                return true;
            }
        } catch (error) {
            console.log(error);
            return false;
        }
    }

    *updateReferralCode(id: string | number, payload: any) {
        try {
            const res: ResponseData = yield this.rootStore.apiStore.call(this.api, this.api.updateReferralCode, { id, payload });
            if (res.ok) {
                return true;
            }
        } catch (error) {
            console.log(error);
            return false;
        }
    }

    *getAllReferralCodes(searchParams: any, paging?: TableState) {
        try {
            const payload = { ...this.convertPagingFromTableToRequest(paging ?? this.paging), ...searchParams };
            const res: ResponseData<GetAllReferralCodeResponse> = yield this.rootStore.apiStore.call(this.api, this.api.getAllReferralCode, payload);
            if (res.ok) {
                this.referralCodes = res.data.elements;
                this.totalByStatus = res.data.totalByStatus;
                this.paging = {
                    ...this.paging,
                    sorting: paging?.sorting ?? [],
                    pagination: this.convertPaginationFromRequestToTable(res.data.pagination)
                };
                this.totalRecord = res.data.pagination.totalRecord;
            }
        } catch (error) {
            console.log(error);
        }
    }

    *getReferralCodeDetail(payload: any, id: string | number) {
        try {
            const res: ResponseData<GetAllReferralCodeDetailResponse> = yield this.rootStore.apiStore.call(this.api, this.api.getReferralCodeDetail, { payload, id });
            if (res.ok) {
                this.referralCodeDetail = res.data;
            }
        } catch (error) {
            console.log(error);
        }
    }

    *changeStatusReferralCode(id: string, payload: any) {
        try {
            const res: ResponseData = yield this.rootStore.apiStore.call(this.api, this.api.changeStatusReferralCode, { id, payload });
            if (res.ok) {
                return res;
            }
        } catch (error) {
            console.log(error);
            return false;
        }
    }
}
